export default __webpack_public_path__ + "static/media/brand.a6084a78.png";